module.exports = __webpack_public_path__ + "static/media/car.61a23fd4.svg";